import { useRouter } from "@core/Api/useRouter";
import ModalToOpenService from "@core-ui/ContextServices/ModalToOpenService/ModalToOpenService";
import ModalToOpen from "@core-ui/ContextServices/ModalToOpenService/model/ModalsToOpen";
import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import { useEffect } from "react";

const QUERY_PARAM_MODALS = {
	inviteMismatch: ModalToOpen.GesCloudInviteMismatch,
	organizationAccessDenied: ModalToOpen.GesCloudOrganizationAccessDenied,
};

const useGesCloudQueryModalsHandler = (isFirstLoad: boolean) => {
	const router = useRouter();
	const { isReadOnly } = PageDataContextService.value.conf;
	const { url: gesCloudUrl } = PageDataContextService.value.conf.enterpriseCloud;

	// biome-ignore lint/correctness/useExhaustiveDependencies: should be called only once
	useEffect(() => {
		if (!isFirstLoad || isReadOnly || !gesCloudUrl) return;

		const query = router.query;
		const modalsToOpen = Object.entries(QUERY_PARAM_MODALS).filter(([param]) => query[param] === "true");
		if (!modalsToOpen.length) return;

		for (const [param, modal] of modalsToOpen) {
			const modalId = ModalToOpenService.addModal(modal, {
				onClose: () => ModalToOpenService.removeModal(modalId),
			});
			delete query[param];
		}
		router.pushQuery(query);
	}, [isFirstLoad]);
};

export default useGesCloudQueryModalsHandler;
